import { Navigate, useParams } from 'react-router-dom';

import { withAuth } from '@/components/auth';
import ExpenseFormWrapper from '@/components/expenses/ExpenseFormWrapper';

function CreateExpensePage() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <Navigate to="/groups" replace />;
  }

  return <ExpenseFormWrapper groupId={id} mode="create" />;
}

export default withAuth(CreateExpensePage, { allowOffline: true });
